<section class="feature-page">
  <app-page-header
    icon="account_tree"
    [title]="unit ? 'Historial de cambios de ' + unit.name : 'Historial de cambios'"
    subtitle="Registro de cambios estructurales de unidad superior.">
  </app-page-header>

  <div class="feature-page__content">

    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Error -->
    <div *ngIf="errorMessage && !isLoading" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{ errorMessage }}</p>
    </div>

    <div *ngIf="!isLoading && !errorMessage" class="unit-content">

      <mat-card class="main-card">

        <!-- Empty state -->
        <div *ngIf="history.length === 0" class="empty-state">
          <mat-icon>history</mat-icon>
          <p>Esta unidad no tiene cambios de unidad superior registrados.</p>
        </div>

        <!-- Table -->
        <div class="table-wrapper" *ngIf="history.length > 0">
          <table mat-table [dataSource]="history" class="history-table">

            <!-- Fecha efectiva -->
            <ng-container matColumnDef="effectiveDate">
              <th mat-header-cell *matHeaderCellDef>Fecha efectiva</th>
              <td mat-cell *matCellDef="let row">
                {{ row.effectiveDate | date:'dd/MM/yyyy' }}
              </td>
            </ng-container>

            <!-- Unidad anterior -->
            <ng-container matColumnDef="fromUnit">
              <th mat-header-cell *matHeaderCellDef>Unidad anterior</th>
              <td mat-cell *matCellDef="let row">
                <span
                  *ngIf="row.fromParentUnitName; else noUnit"
                  class="unit-link"
                  [class.clickable]="row.fromParentUnitId"
                  (click)="navigateToUnit(row.fromParentUnitId)"
                  [matTooltip]="row.fromParentUnitId ? 'Ir a la unidad' : ''">
                  {{ row.fromParentUnitName }}
                </span>
                <ng-template #noUnit>
                  <span class="no-value">Sin unidad superior</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- Unidad nueva -->
            <ng-container matColumnDef="toUnit">
              <th mat-header-cell *matHeaderCellDef>Nueva unidad superior</th>
              <td mat-cell *matCellDef="let row">
                <span
                  *ngIf="row.toParentUnitName; else noUnit2"
                  class="unit-link"
                  [class.clickable]="row.toParentUnitId"
                  (click)="navigateToUnit(row.toParentUnitId)"
                  [matTooltip]="row.toParentUnitId ? 'Ir a la unidad' : ''">
                  {{ row.toParentUnitName }}
                </span>
                <ng-template #noUnit2>
                  <span class="no-value">—</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- Motivo -->
            <ng-container matColumnDef="reason">
              <th mat-header-cell *matHeaderCellDef>Motivo</th>
              <td mat-cell *matCellDef="let row">
                <span *ngIf="row.reason; else noReason">{{ row.reason }}</span>
                <ng-template #noReason>
                  <span class="no-value">Sin motivo</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- Registrado -->
            <ng-container matColumnDef="registeredAt">
              <th mat-header-cell *matHeaderCellDef>Registrado</th>
              <td mat-cell *matCellDef="let row">
                <div class="registered-cell">
                  <span class="registered-date">{{ row.createdAtUtc | date:'dd/MM/yyyy HH:mm' }}</span>
                  <span *ngIf="row.createdByUserName" class="registered-by">
                    <mat-icon>person</mat-icon>{{ row.createdByUserName }}
                  </span>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          </table>
        </div>

      </mat-card>

    </div>
  </div>

</section>
